import axios from 'axios';

const resolveApiBaseUrl = () => {
  const configuredBaseUrl = process.env.REACT_APP_BACKEND_URL?.trim();
  if (!configuredBaseUrl) {
    return '/api';
  }

  const normalizedBaseUrl = configuredBaseUrl.replace(/\/+$/, '');
  return normalizedBaseUrl || '/api';
};

const api = axios.create({
  baseURL: resolveApiBaseUrl(),
});

export const sendMessage = (messages) =>
  api.post('/chat', { messages }).then(r => r.data);

export const getLeads = () =>
  api.get('/leads').then(r => r.data);

export const getLeadById = (id) =>
  api.get(`/leads/${id}`).then(r => r.data);

export const updateLead = (id, data) =>
  api.patch(`/leads/${id}`, data).then(r => r.data);

export const submitContactForm = (formData) =>
  api.post('/contact', formData).then(r => r.data);
export default api;
